const settingsUtils = {
  // Check if a value is empty (null, undefined, empty string, or empty array)
  isEmpty(value: any): boolean {
    return (
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0)
    );
  },

  // Deep clone an object or array
  deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  },

  // Merge two objects deeply
  deepMerge<T, U>(target: T, source: U): T & U {
    const output = { ...target } as any;
    if (typeof target === 'object' && typeof source === 'object') {
      for (const key in source) {
        if (
          source[key] &&
          typeof source[key] === 'object' &&
          !Array.isArray(source[key])
        ) {
          output[key] = settingsUtils.deepMerge(output[key] || {}, source[key]);
        } else {
          output[key] = source[key];
        }
      }
    }
    return output;
  },

  // Capitalize the first letter of a string
  capitalize(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  // Debounce a function
  debounce<T extends (...args: any[]) => void>(fn: T, delay: number) {
    let timer: NodeJS.Timeout;
    return (...args: Parameters<T>) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  },

  // Validate US and Canada postal codes with optional country enforcement
  // If country is provided and is 'USA' or 'Canada', enforce the corresponding format.
  // If country is not provided, accept either format.
  isValidPostalCode(postcode: string, country: string = 'USA'): boolean {
    if (!postcode) return false;
    const value = postcode.trim();
    const usRegex = /^\d{5}(-\d{4})?$/;
    const caRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    if (country === 'USA') {
      return usRegex.test(value);
    }
    if (country === 'Canada') {
      return caRegex.test(value);
    }
    // No country specified: accept either
    return false;
  }
};

export default settingsUtils;